/* Wig Try-On — product page modal */
(function () {
  const W = window.WigTryOn;

  document.querySelectorAll('.wt').forEach(init);

  function init(root) {
    const cfg = JSON.parse(root.querySelector('[data-wt-config]').textContent);
    const $ = (s) => root.querySelector(s);

    const modal = $('[data-wt-modal]');
    const canvas = $('[data-wt-canvas]');
    const status = $('[data-wt-status]');
    const spinner = $('[data-wt-spinner]');
    const spinnerText = $('[data-wt-spinner-text]');
    const consentRow = $('[data-wt-consent-row]');
    const consent = $('[data-wt-consent]');
    const uploadBtn = $('[data-wt-upload]');
    const fileInput = $('[data-wt-file]');
    const resultActions = $('[data-wt-result-actions]');
    const tray = $('[data-wt-tray]');
    const trayWrap = $('[data-wt-tray-wrap]');
    const emailWrap = $('[data-wt-email-wrap]');
    const emailInput = $('[data-wt-email]');
    const meBtn = $('[data-wt-me]');
    const atc = $('[data-wt-atc]');

    const state = {
      wigImage: cfg.wigImage,
      variantId: cfg.variantId,
      modelId: null,          // null = the customer's own photo
      modelImage: null,
      current: null,
      original: canvas.src
    };

    // Only the newest run is allowed to touch the UI. Without this, a slow
    // earlier request can resolve late and re-show or strand the spinner.
    let runToken = 0;

    // Someone who uploaded on another PDP should not be asked again.
    if (W.store.getPhoto()) unlockReturningVisitor();

    W.store.subscribe(renderTray);
    renderTray();

    $('[data-wt-open]').addEventListener('click', open);
    $('[data-wt-close]').addEventListener('click', close);
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });

    function open() {
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
      W.track('wig_tryon_opened', {
        productId: cfg.productId, productTitle: cfg.productTitle, surface: 'pdp'
      });
      renderTray();
    }
    function close() {
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
    }

    consent.addEventListener('change', () => { uploadBtn.disabled = !consent.checked; });

    function unlockReturningVisitor() {
      consentRow.hidden = true;
      uploadBtn.disabled = false;
      uploadBtn.textContent = 'Use a different photo';
      meBtn.hidden = false;
    }

    // Variant swatches re-render against whatever face is in play.
    root.querySelectorAll('[data-wt-variant]').forEach((btn) => {
      btn.addEventListener('click', () => {
        root.querySelectorAll('[data-wt-variant]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        state.variantId = btn.dataset.wtVariant;
        state.wigImage = btn.dataset.wtVariantImage;
        run();
      });
    });

    // Starter models — served from the pre-generated cache, effectively instant.
    root.querySelectorAll('[data-wt-model]').forEach((btn) => {
      btn.addEventListener('click', () => {
        clearFaceSelection();
        btn.classList.add('is-active');
        state.modelId = btn.dataset.wtModel;
        state.modelImage = btn.dataset.wtModelImage;
        run();
      });
    });

    meBtn.addEventListener('click', () => {
      clearFaceSelection();
      meBtn.classList.add('is-active');
      state.modelId = null;
      state.modelImage = null;
      run();
    });

    function clearFaceSelection() {
      root.querySelectorAll('[data-wt-model], [data-wt-me]').forEach((b) => b.classList.remove('is-active'));
    }

    uploadBtn.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', async () => {
      const file = fileInput.files && fileInput.files[0];
      fileInput.value = '';
      if (!file) return;
      if (file.size > 20 * 1024 * 1024) return fail('That file is over 20MB. Try a smaller photo.');

      busy(true, 'Checking your photo…');
      try {
        const photo = await W.downscale(file);
        const check = await W.checkFace(photo);
        if (!check.ok) { busy(false); return fail(check.message); }
        W.store.setPhoto(photo);
        state.modelId = null;
        state.modelImage = null;
        unlockReturningVisitor();
        clearFaceSelection();
        meBtn.classList.add('is-active');
        await run();
      } catch (e) {
        busy(false);
        fail(e.message);
      }
    });

    async function run() {
      const usingOwnPhoto = state.modelId === null;
      const photo = usingOwnPhoto ? W.store.getPhoto() : null;
      if (usingOwnPhoto && !photo) return;   // nothing to render against yet

      const myRun = ++runToken;
      busy(true, 'Building your look…');
      status.textContent = '';

      try {
        const out = await W.generate({
          endpoint: cfg.endpoint,
          photo,
          modelId: state.modelId,
          modelImage: state.modelImage,
          wigImage: state.wigImage,
          productId: cfg.productId,
          productTitle: cfg.productTitle,
          productUrl: cfg.productUrl,
          variantId: state.variantId,
          texture: cfg.texture,
          capType: cfg.capType
        }, (msg) => { if (myRun === runToken) spinnerText.textContent = msg; });

        if (myRun !== runToken) return;      // superseded by a newer run

        busy(false);                          // drop the overlay before painting
        state.current = out.image;
        canvas.src = out.image;
        resultActions.hidden = false;
        emailWrap.hidden = !usingOwnPhoto;
        status.textContent = out.flagged
          ? 'Color may read slightly differently in person — check the product photos too.'
          : 'AI preview — styling reference only.';
      } catch (e) {
        if (myRun !== runToken) return;
        // Never leave a dead frame. Fall back to a preset look on the same product.
        const fallback = root.querySelector('[data-wt-model]');
        if (e.degraded) {
          uploadBtn.disabled = true;
          uploadBtn.textContent = 'Try-on paused for today';
        }
        if (usingOwnPhoto && fallback) {
          fail(e.message + ' Showing it on a model instead.');
          busy(false);
          fallback.click();
          return;
        }
        canvas.src = state.original;
        fail(e.message);
      } finally {
        if (myRun === runToken) busy(false);
      }
    }

    /* --- compare tray --- */

    function renderTray() {
      const looks = W.store.tray();
      trayWrap.hidden = looks.length < 2;
      tray.innerHTML = '';
      looks.forEach((look) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'wt__tray-item' + (look.image === state.current ? ' is-active' : '');
        const img = document.createElement('img');
        img.src = look.image;
        img.alt = look.title;
        img.loading = 'lazy';
        const label = document.createElement('span');
        label.textContent = look.title;
        b.append(img, label);
        b.addEventListener('click', () => {
          state.current = look.image;
          state.variantId = look.variantId;
          canvas.src = look.image;
          resultActions.hidden = false;
          if (look.url && look.url !== cfg.productUrl) {
            status.textContent = '';
            const a = document.createElement('a');
            a.href = look.url;
            a.textContent = look.title;
            status.append('Viewing ', a);
          } else {
            status.textContent = 'AI preview — styling reference only.';
          }
          renderTray();
        });
        tray.appendChild(b);
      });
    }

    /* --- output actions --- */

    $('[data-wt-download]').addEventListener('click', () => {
      if (state.current) W.download(state.current, cfg.productTitle);
    });

    $('[data-wt-share]').addEventListener('click', async () => {
      if (!state.current) return;
      const shared = await W.share(state.current, cfg.productTitle).catch(() => false);
      if (!shared) W.download(state.current, cfg.productTitle);
    });

    $('[data-wt-reset]').addEventListener('click', () => {
      W.store.clear();
      state.current = null;
      state.modelId = null;
      canvas.src = state.original;
      resultActions.hidden = true;
      emailWrap.hidden = true;
      consentRow.hidden = false;
      consent.checked = false;
      uploadBtn.disabled = true;
      uploadBtn.textContent = 'Upload your photo';
      meBtn.hidden = true;
      clearFaceSelection();
      status.textContent = 'Photo cleared.';
    });

    $('[data-wt-email-send]').addEventListener('click', async () => {
      const email = emailInput.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('That email does not look right.');
      const btn = $('[data-wt-email-send]');
      btn.disabled = true;
      btn.textContent = 'Sending…';
      try {
        await W.saveLook({
          endpoint: cfg.endpoint,
          email,
          productId: cfg.productId,
          productTitle: cfg.productTitle,
          variantId: state.variantId,
          url: cfg.productUrl
        });
        emailWrap.textContent = '';
        const done = document.createElement('p');
        done.className = 'wt__sent';
        done.textContent = 'Sent. Check your inbox.';
        emailWrap.appendChild(done);
      } catch (e) {
        btn.disabled = false;
        btn.textContent = 'Send it';
        fail(e.message);
      }
    });

    atc.addEventListener('click', async () => {
      atc.disabled = true;
      atc.textContent = 'Adding…';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: state.variantId, quantity: 1 }] })
        });
        W.track('wig_tryon_add_to_cart', {
          productId: cfg.productId, productTitle: cfg.productTitle,
          variantId: state.variantId, surface: 'pdp',
          usedOwnPhoto: state.modelId === null
        });
        window.location.href = '/cart';
      } catch {
        atc.disabled = false;
        atc.textContent = 'Add to cart';
        fail('Could not add to cart. Close this and use the button on the page.');
      }
    });

    function busy(on, text) {
      spinner.hidden = !on;
      if (text) spinnerText.textContent = text;
      uploadBtn.disabled = on || (!consent.checked && !consentRow.hidden);
    }

    function fail(msg) {
      status.textContent = msg;
      status.classList.add('is-error');
      setTimeout(() => status.classList.remove('is-error'), 5000);
    }
  }
})();
